


















import Vue from 'vue';
import SocialMedia from '@/components/SocialMedia.vue';
import Copyright from '@/components/Copyright.vue';
import Contact from '@/components/Contact.vue';

export default Vue.extend({
  name: 'StormFooter',
  components: {
    SocialMedia,
    Copyright,
    Contact,
  },
});
